export {
    formatActivityDate,
    formatActivityDateTime,
    LAST_LOGIN_ANY,
    STATUS_ACTIVE,
    STATUS_INVITE_EXPIRED,
    STATUS_INVITED,
} from '../../admin/users/activity/userActivityFormat';

export const STATUS_DEACTIVATED = 'deactivated';

export const ORG_ROLE_ADMIN = 'organisation_admin';
export const ORG_ROLE_USER = 'organisation_user';

export const MFA_ALL = 'all';
export const PROJECT_NONE = 'none';

export const PER_PAGE_OPTIONS = [25, 50, 100];

export const DEFAULT_QUERY = {
    search: null,
    project: null,
    org_role: null,
    status: null,
    last_login: 'any',
    mfa: MFA_ALL,
    sort: 'name',
    direction: 'asc',
    per_page: 25,
};

export const orgRoleLabel = (orgRole) => (orgRole === ORG_ROLE_ADMIN ? $t('Organisation Admin') : $t('Organisation user'));

export const isInvitePending = (status) => status === 'invited' || status === 'invite_expired';

/**
 * The page's query as request parameters: empty filters are left out.
 */
export function queryParams(query) {
    const params = {};

    Object.entries(query).forEach(([key, value]) => {
        if (value !== null && value !== '' && value !== undefined) {
            params[key] = value;
        }
    });

    return params;
}
